import React, { useState } from 'react';
import { DetTitle, FilterH, LoginHead, MeasureSize, NewsLetterStyle } from '../../../StyledComponents';
import { Col, Row, Table } from 'reactstrap';
import warranty from '../../../assets/images/icons/warranty.svg'
import Videos from '../../Manage/Videos';
import Rating from 'react-rating';
import { Star } from 'react-feather';
import { FcGenericSortingDesc } from "react-icons/fc";
import { IoIosArrowDown, IoIosStarOutline, IoIosArrowForward } from "react-icons/io";
import { AiOutlineDislike, AiOutlineLike } from "react-icons/ai";
import FAQ from '../../../components/common/FAQ/FAQ';
import ProductReviewForm from '../../UserPortal/Orders/ProductReviewForm/ProductReviewForm';
import styles from './ProductListingDesc.module.scss';

const ProductListingDesc = ({ fetchProduct }) => {
  const [selectedTab, setSelectedTab] = useState('details');
  const [showProductReviewForm, setShowProductReviewForm] = useState(false);
  const questions = [
    { question: "What sizes are available for this shirt?", answer: "The shirt is available in S, M, L, XL, and XXL." },
    { question: "Can I machine wash this shirt?", answer: "Yes, you can machine wash this shirt in cold water." },
    { question: "Is this shirt suitable for both casual and formal occasions?", answer: "Yes, the shirt is versatile and suitable for both casual and formal occasions." },
    { question: "Do you offer free shipping?", answer: "Free shipping is available on orders over $50." },
    { question: "What is your return policy?", answer: "You can return the shirt within 30 days of purchase for a full refund." },
    { question: "How do I know if this shirt will fit me correctly?", answer: "Please refer to our size chart for accurate measurements." },
    { question: "Can I track my order?", answer: "Yes, you will receive a tracking number once your order is shipped." },
    { question: "Are the colors of the shirt true to the images on the website?", answer: "We strive to display the colors as accurately as possible, but there may be slight variations." },
    { question: "Can I track my order?", answer: "Yes, you can track your order using the tracking number provided in the confirmation email." },
    { question: "Are the colors of the shirt true to the images on the website?", answer: "Yes, we ensure that the colors are as close to the actual product as possible." },
  ];

  const toggleShowProductReviewForm = () => {
    setShowProductReviewForm(!showProductReviewForm);
  };

  const handleTabChange = (tab) => {
    setSelectedTab(tab);
  };


  const measurementData = [
    {
      heading: 'Chest:',
      description: 'Measure around the fullest part of your chest, keeping the tape measure horizontal.',
    },
    {
      heading: 'Waist:',
      description: 'Measure around the narrowest part of your waist, keeping the tape measure horizontal.',
    },
    {
      heading: 'Hip:',
      description: 'Measure around the fullest part of your hips, keeping the tape measure horizontal.',
    },
    {
      heading: 'Shoulder Width:',
      description: 'Measure from the edge of one shoulder to the other across the back.',
    },
    {
      heading: 'Sleeve Length:',
      description: 'Measure from the shoulder seam to the end of the sleeve.',
    },
    {
      heading: 'Shirt Length:',
      description: 'Measure from the highest point on the shoulder (near the neck) to the bottom hem.',
    },
  ];

  const measurementNotes = [
    "Always measure over bare skin or thin clothing to ensure accuracy.",
    "Stand straight and relaxed while measuring.",
    "If you're between sizes, consider the fit you prefer (looser or more fitted) and select accordingly."
  ];

  const tshirtData = {
    description: "Experience the pinnacle of performance and comfort with our sports T-Shirts. Engineered to amplify your active lifestyle, these shirts are the ultimate companions for various sports and activities, including running, hiking, football, basketball, cricket, and soccer.",
    properties: {
      general: [
        "High quality",
        "Good fabric",
        "Premium quality",
        "Stylish",
        "Trendy",
        "Double stitched"
      ],
      specific: [
        "Sports fit",
        "Light weight",
        "Fabric cotton jersey",
        "Soft fabric",
        "Very comfortable",
        "Durable and washable"
      ]
    },
    additionalInfo: {
      description: "Crafted to provide optimal comfort and performance, these Round neck T-shirts are designed for those who demand excellence from their athletic wear. The innovative features ensure you stay focused and comfortable during even the most rigorous workouts.",
      careInstructions: "You can wash it in washing machine. Do not dry in sunlight and wash with sweet water."
    }
  };

  return (
    <div className={styles.productListingDescContainer}>
      <div className={styles.filterTabBar}>
        <DetTitle
          onClick={() => handleTabChange('details')}
          style={{
            padding: '0',
            // marginRight: '60px',
            cursor: 'pointer',
            fontWeight: selectedTab === 'details' ? 'bold' : 'normal',
            color: selectedTab === 'details' ? '#EC7426' : '#000', // Use a valid color for inactive state
            borderBottom: selectedTab === 'details' ? '3px solid #EC7426' : 'none',
          }}
        >
          Details
        </DetTitle>
        <DetTitle
          onClick={() => handleTabChange('productSpecs')}
          style={{
            padding: '0',
            // marginRight: '60px',
            cursor: 'pointer',
            fontWeight: selectedTab === 'productSpecs' ? 'bold' : 'normal',
            color: selectedTab === 'productSpecs' ? '#EC7426' : '#000', // Use a valid color for inactive state
            borderBottom: selectedTab === 'productSpecs' ? '3px solid #EC7426' : 'none',
          }}
        >
          Product Specs
        </DetTitle>
        <DetTitle
          onClick={() => handleTabChange('warranty')}
          style={{
            padding: '0',
            // marginRight: '60px',
            cursor: 'pointer',
            fontWeight: selectedTab === 'warranty' ? 'bold' : 'normal',
            color: selectedTab === 'warranty' ? '#EC7426' : '#000', // Use a valid color for inactive state
            borderBottom: selectedTab === 'warranty' ? '3px solid #EC7426' : 'none',
          }}
        >
          Warranty
        </DetTitle>
        <DetTitle
          onClick={() => handleTabChange('reviews')}
          style={{
            padding: '0',
            // marginRight: '60px',
            cursor: 'pointer',
            fontWeight: selectedTab === 'reviews' ? 'bold' : 'normal',
            color: selectedTab === 'reviews' ? '#EC7426' : '#000', // Use a valid color for inactive state
            borderBottom: selectedTab === 'reviews' ? '3px solid #EC7426' : 'none',
          }}
        >
          Reviews
        </DetTitle>
        <DetTitle
          onClick={() => handleTabChange('faqs')}
          style={{
            padding: '0',
            // marginRight: '60px',
            cursor: 'pointer',
            fontWeight: selectedTab === 'faqs' ? 'bold' : 'normal',
            color: selectedTab === 'faqs' ? '#EC7426' : '#000', // Use a valid color for inactive state
            borderBottom: selectedTab === 'faqs' ? '3px solid #EC7426' : 'none',
          }}
        >
          FAQs
        </DetTitle>
      </div>

      <div style={{ marginTop: '20px' }}>
        {selectedTab === 'details' &&
          <div>
            <Row style={{ borderBottom: '1px solid #D9D9D9', margin: '0', paddingBottom: '20px', rowGap: '20px' }} flex>
              <Col xl='6' lg='6' md='6' sm='12' xs='12'>
                {/* <MeasureSize>{tshirtData.description}</MeasureSize> */}
                <MeasureSize dangerouslySetInnerHTML={{ __html: fetchProduct?.productDetails }} />
                <div>
                  <Row style={{ rowGap: '10px' }} flex>
                    <Col xl='6' lg='6' md='6' sm='12' xs='12'>
                      <NewsLetterStyle style={{ fontWeight: '600' }}>Properties</NewsLetterStyle>
                      <div>
                        {tshirtData.properties.general.map((property, index) => (
                          <MeasureSize key={index} className="text-start">{property}</MeasureSize>
                        ))}
                      </div>
                    </Col>
                    <Col xl='6' lg='6' md='6' sm='12' xs='12'>
                      <NewsLetterStyle style={{ fontWeight: '600' }}>Properties</NewsLetterStyle>
                      <div>
                        {tshirtData.properties.specific.map((property, index) => (
                          <MeasureSize key={index} className="text-start">{property}</MeasureSize>
                        ))}
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col xl='6' lg='6' md='6' sm='12' xs='12'>
                <MeasureSize>{tshirtData.additionalInfo.description}</MeasureSize>
                <NewsLetterStyle style={{ fontWeight: '600' }}>Note:</NewsLetterStyle>
                <MeasureSize>{tshirtData.additionalInfo.careInstructions}</MeasureSize>
              </Col>
            </Row>
            <Row style={{ borderBottom: '1px solid #D9D9D9', margin: '20px 0 0 0', paddingBottom: '20px' }} flex>
              <Col xl='6' lg='6' md='6' sm='12' xs='12'>
                <NewsLetterStyle style={{ fontWeight: '600' }}>Brand:</NewsLetterStyle>
                <MeasureSize>{`${fetchProduct?.brand?.brandName}` || "No brand"}</MeasureSize>
              </Col>
              <Col xl='6' lg='6' md='6' sm='12' xs='12'>
                <NewsLetterStyle style={{ fontWeight: '600' }}>SKU:</NewsLetterStyle>
                <MeasureSize>123454523_PK-1380566809</MeasureSize>
              </Col>
              <Col xl='6' lg='6' md='6' sm='12' xs='12'>
                <NewsLetterStyle style={{ fontWeight: '600' }}>Customization options:</NewsLetterStyle>
                <MeasureSize>Gift wrapping</MeasureSize>
              </Col>
            </Row>
            <div style={{ paddingBottom: '20px' }}>
              <NewsLetterStyle className='py-4' style={{ fontWeight: '600' }}>Videos</NewsLetterStyle>
              <Videos fetchProduct={fetchProduct} />
            </div>
          </div>
        }

        {selectedTab === 'productSpecs' &&
          <div>
            <FilterH>Product Specifications</FilterH>
            <div className='p-2 p-md-4'>
              <Table bordered borderless responsive>
                <tbody>

                  <tr>
                    <td>Material</td>
                    <td>{fetchProduct?.specs?.material}</td>
                  </tr>

                  {/* {data.map((item, index) => (
                    <tr key={index}>
                      <td >{item.label}</td>
                      <td>{item.value}</td>
                    </tr>
                  ))} */}
                </tbody>
              </Table>
            </div>

            <FilterH>Size Chart</FilterH>
            <div className='p-2 p-md-4'>
              <img className='img-fluid' src={fetchProduct?.sizeChartImage} />

              {/* <Table bordered responsive>
                <thead>
                  <tr>
                    <th>Size</th>
                    <th>Shirt Length (inches)</th>
                    <th>Chest (inches)</th>
                    <th>Waist (inches)</th>
                    <th>Hip (inches)</th>
                  </tr>
                </thead>
                <tbody>
                  {sizeData.map((item, index) => (
                    <tr key={index}>
                      <td>{item.size}</td>
                      <td>{item.length}</td>
                      <td>{item.chest}</td>
                      <td>{item.waist}</td>
                      <td>{item.hip}</td>
                    </tr>
                  ))}
                </tbody>
              </Table> */}
            </div>

            <FilterH>How to Measure Your Body Size</FilterH>
            <div className='p-2 p-md-4'>
              <ol style={{ fontWeight: '600', margin: '0' }}>
                {measurementData.map((item, index) => (
                  <li key={index}>
                    <MeasureSize style={{ fontWeight: '600' }}>{item.heading}</MeasureSize>
                    <ul style={{ listStyleType: 'disc' }}>
                      <li><MeasureSize>{item.description}</MeasureSize></li>
                    </ul>
                  </li>
                ))}
              </ol>
            </div>

            <FilterH>Additional Tips</FilterH>
            <div className='p-2 p-md-4'>
              <ul style={{ listStyleType: 'disc', margin: '0' }}>
                {measurementNotes.map((note, index) => (
                  <li key={index} style={{ marginBottom: '10px' }}>
                    <MeasureSize> {note} </MeasureSize>
                  </li>
                ))}
              </ul>
            </div>

            <div style={{ paddingBottom: '20px' }}>
              <NewsLetterStyle className='pb-3' style={{ fontWeight: '600' }}>Videos</NewsLetterStyle>
              <Videos fetchProduct={fetchProduct} />
            </div>
          </div>
        }

        {selectedTab === 'warranty' &&
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <img width={'35px'} height={'35px'} src={warranty} />
              <LoginHead style={{ color: 'black' }}>{`${fetchProduct?.legalAndCompliance?.warranty}` || "No warranty issued by the seller"}</LoginHead>
            </div>
            <div style={{ paddingBottom: '20px', }}>
              <NewsLetterStyle className='py-3' style={{ fontWeight: '600' }}>Videos</NewsLetterStyle>
              <Videos fetchProduct={fetchProduct} />
            </div>
          </div>
        }

        {selectedTab === 'reviews' &&
          <div>
            <div className={styles.reviewsContainer}>
              <div style={{ display: 'flex', gap: '1rem' }}>
                <div style={{ fontWeight: 500, fontSize: '4rem' }}>4.8</div>

                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <div>
                    <Rating
                      readonly={true}
                      initialRating={4.5}
                      emptySymbol={
                        <Star size={18} fill="#babfc7" stroke="#babfc7" />
                      }
                      fullSymbol={
                        <Star
                          size={18}
                          fill="#fbbd34"
                          stroke="#fbbd34"
                        />
                      }
                    />
                  </div>
                  <div>
                    Average (100 reviews)
                  </div>
                </div>
              </div>

              <div className={styles.ratingsContainer}>
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", alignItems: 'center', gap: '1rem' }}>
                    <div>
                      <Rating
                        readonly={true}
                        initialRating={5}
                        emptySymbol={
                          <Star size={18} fill="#babfc7" stroke="#babfc7" />
                        }
                        fullSymbol={
                          <Star
                            size={18}
                            fill="#fbbd34"
                            stroke="#fbbd34"
                          />
                        }
                      />
                    </div>
                    <div className={styles.ratingBar}>
                      <div style={{ backgroundColor: '#f2f2f2', height: '1rem', borderRadius: '.5rem', flex: 1 }}>
                        <div style={{ backgroundColor: '#fabc42', width: '80%', height: '100%', borderRadius: '.5rem' }} ></div>
                      </div>
                    </div>
                    <div style={{ width: '5%' }}>80</div>
                  </div>
                  <div style={{ display: "flex", alignItems: 'center', gap: '1rem' }}>
                    <div>
                      <Rating
                        readonly={true}
                        initialRating={4}
                        emptySymbol={
                          <Star size={18} fill="#babfc7" stroke="#babfc7" />
                        }
                        fullSymbol={
                          <Star
                            size={18}
                            fill="#fbbd34"
                            stroke="#fbbd34"
                          />
                        }
                      />
                    </div>
                    <div className={styles.ratingBar}>
                      <div style={{ backgroundColor: '#f2f2f2', height: '1rem', borderRadius: '.5rem', flex: 1 }}>
                        <div style={{ backgroundColor: '#fabc42', width: '10%', height: '100%', borderRadius: '.5rem' }} ></div>
                      </div>
                    </div>
                    <div style={{ width: '5%' }}>10</div>
                  </div>
                  <div style={{ display: "flex", alignItems: 'center', gap: '1rem' }}>
                    <div>
                      <Rating
                        readonly={true}
                        initialRating={3}
                        emptySymbol={
                          <Star size={18} fill="#babfc7" stroke="#babfc7" />
                        }
                        fullSymbol={
                          <Star
                            size={18}
                            fill="#fbbd34"
                            stroke="#fbbd34"
                          />
                        }
                      />
                    </div>
                    <div className={styles.ratingBar}>
                      <div style={{ backgroundColor: '#f2f2f2', height: '1rem', borderRadius: '.5rem', flex: 1 }}>
                        <div style={{ backgroundColor: '#fabc42', width: '5%', height: '100%', borderRadius: '.5rem' }} ></div>
                      </div>
                    </div>
                    <div style={{ width: '5%' }}>5</div>
                  </div>
                  <div style={{ display: "flex", alignItems: 'center', gap: '1rem' }}>
                    <div>
                      <Rating
                        readonly={true}
                        initialRating={2}
                        emptySymbol={
                          <Star size={18} fill="#babfc7" stroke="#babfc7" />
                        }
                        fullSymbol={
                          <Star
                            size={18}
                            fill="#fbbd34"
                            stroke="#fbbd34"
                          />
                        }
                      />
                    </div>
                    <div className={styles.ratingBar}>
                      <div style={{ backgroundColor: '#f2f2f2', height: '1rem', borderRadius: '.5rem', flex: 1 }}>
                        <div style={{ backgroundColor: '#fabc42', width: '3%', height: '100%', borderRadius: '.5rem' }} ></div>
                      </div>
                    </div>
                    <div style={{ width: '5%' }}>3</div>
                  </div>
                  <div style={{ display: "flex", alignItems: 'center', gap: '1rem' }}>
                    <div>
                      <Rating
                        readonly={true}
                        initialRating={1}
                        emptySymbol={
                          <Star size={18} fill="#babfc7" stroke="#babfc7" />
                        }
                        fullSymbol={
                          <Star
                            size={18}
                            fill="#fbbd34"
                            stroke="#fbbd34"
                          />
                        }
                      />
                    </div>
                    <div className={styles.ratingBar}>
                      <div style={{ backgroundColor: '#f2f2f2', height: '1rem', borderRadius: '.5rem', flex: 1 }}>
                        <div style={{ backgroundColor: '#fabc42', width: '2%', height: '100%', borderRadius: '.5rem' }} ></div>
                      </div>
                    </div>
                    <div style={{ width: '5%' }}>2</div>
                  </div>
                </div>
              </div>
            </div>

            {showProductReviewForm && (
              <div style={{ paddingBlock: '3rem', paddingInline: '2rem' }}>
                <ProductReviewForm onCancel={setShowProductReviewForm} />
              </div>
            )}

            <div className={styles.reviewsSectionHeader}>
              <div className='d-flex gap-3'>
                <span className='d-flex'>
                  <span className='d-flex align-items-center'><FcGenericSortingDesc /></span>
                  <span>Sorting</span>
                  <span className='d-flex align-items-center'><IoIosArrowDown /></span>
                </span>
                <span className='d-flex'>
                  <span className='d-flex align-items-center'><IoIosStarOutline /></span>
                  <span>Rating</span>
                  <span className='d-flex align-items-center'><IoIosArrowDown /></span>
                </span>
              </div>
              <div>
                <div style={{ border: '2px solid black', padding: '.3rem', borderRadius: '.5rem', display: 'flex', cursor: 'pointer', gap: '5px' }} onClick={toggleShowProductReviewForm}>
                  <span>Add Your Review</span>
                  <span><IoIosArrowForward style={{ marginBottom: '3px' }} /></span>
                </div>
              </div>
            </div>

            <div className={styles.reviewsList}>
              <div className={styles.reviewDetails}>
                <div className={styles.reviewerInfo}>
                  <div>
                    <span>James Watson</span>
                    <span style={{ fontSize: '.8rem', fontWeight: '400', color: '#9B9B9B', marginLeft: '.5rem' }}>4 days ago</span>
                  </div>
                  <div>
                    <span>(5.0)</span>
                    <span><Rating
                      readonly={true}
                      initialRating={4.5}
                      emptySymbol={
                        <Star size={18} fill="#babfc7" stroke="#babfc7" />
                      }
                      fullSymbol={
                        <Star
                          size={18}
                          fill="#fbbd34"
                          stroke="#fbbd34"
                        />
                      }
                    /></span>
                  </div>
                </div>

                <div className={styles.reviewerReview}>
                  Delighted in your clothing! It is absolutely gorgeous...everything I have ordered FITS PERFECTLY...my fiance has told me how beautiful I look in the outfits I have purchased, as well as receiving many other compliments on the quality of your clothing lines from friends and family! I am so happy I have found you...and I will continue to purchase from you all! Thank you so very much!
                </div>

                <div className={styles.reviewerImgReactions}>
                  <div style={{ display: 'flex', gap: '.5rem' }}>
                    <div><img src='https://placehold.co/51x59?text=Maelano' /></div>
                    <div><img src='https://placehold.co/51x59?text=Maelano' /></div>
                  </div>
                  <div style={{ display: 'flex' }}>
                    <div style={{ padding: '.5rem', display: "flex", alignItems: 'center', justifyContent: 'center', backgroundColor: '#f2f2f2', borderTopLeftRadius: '.5rem', borderBottomLeftRadius: '.5rem', borderRight: '1px solid #d9d9d9', gap: '.3rem' }}><span>12</span><span><AiOutlineLike style={{ marginBottom: '4px' }} /></span></div>
                    <div style={{ padding: '.5rem', display: "flex", alignItems: 'center', justifyContent: 'center', backgroundColor: '#f2f2f2', borderTopRightRadius: '.5rem', borderBottomRightRadius: '.5rem', borderLeft: '1px solid #d9d9d9', gap: '.3rem' }}><span>10</span><span><AiOutlineDislike /></span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

        {selectedTab === 'faqs' &&
          <div>
            <div className={styles.questionAskedContainer}>
              <div className={styles.questionHeadingWrapper}>
                <div>
                  <h2 style={{ margin: 0 }}>30 Questions Asked</h2>
                  <p style={{ margin: 0, color: '#666' }}>Prompt replied</p>
                </div>
                <span>View All</span>
              </div>

              <div className={styles.percentageBarsWrapper}>
                <div>
                  <div style={{ backgroundColor: '#f2f2f2', height: '1rem', width: '200px', borderRadius: '0.5rem', overflow: 'hidden' }}>
                    <div style={{ backgroundColor: '#fabc42', width: '90%', height: '100%', borderRadius: '0.5rem' }}></div>
                  </div>
                  <p style={{ margin: 0, color: '#666', fontSize: '0.9rem' }}>Questions Answered 90%</p>
                </div>
                <div>
                  <div style={{ backgroundColor: '#f2f2f2', height: '1rem', width: '200px', borderRadius: '0.5rem', overflow: 'hidden' }}>
                    <div style={{ backgroundColor: '#fabc42', width: '10%', height: '100%', borderRadius: '0.5rem' }}></div>
                  </div>
                  <p style={{ margin: 0, color: '#666', fontSize: '0.9rem' }}>Questions Pending 10%</p>
                </div>
              </div>
            </div>

            <div>
              <FAQ faqs={questions} />
            </div>
          </div>
        }
      </div>
    </div>
  );
};

export default ProductListingDesc;